interface DateFilterProps {
    value: string
    onChange: (date: string) => void
  }
  
  const DateFilter: React.FC<DateFilterProps> = ({ value, onChange }) => {
    return (
      <div className="mb-4 flex items-center space-x-2">
        <label className="font-semibold">Filtra per data:</label>
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="border rounded px-2 py-1"
        />
      </div>
    )
  }
  
  export default DateFilter